/*
    function to construct a URL when user interacts
    with the Case Studies archive filter form
*/
// add query parameters to constructed URL
function construct_query_parameters (list_id, query_url, parameter_name) {
    const checkbox_list = document.getElementById(list_id);
    if (checkbox_list) {
        // retrieve all checkboxes in this list
        const checkboxes = Array.from(checkbox_list.getElementsByClassName("filters__checkbox_input"));
        if (checkboxes) {
            let checked_parameters = [];
            checkboxes.forEach((checkbox) => {
                // if checkbox is checked:
                if (checkbox.checked) {
                    // add checkbox's name to the list of query parameters
                    checked_parameters.push(checkbox.name);
                }
            });
            if (checked_parameters.length) {
                checked_parameters = checked_parameters.join(",");
                query_url.searchParams.append(parameter_name, checked_parameters);
            }
        }
    }
}
/*
    function to toggle visibility of filter checkbox lists
    when user interacts with each list's button
*/
function toggle_filter_list_visibility (show_button_id, list_id) {
    // retreive button which makes list visible
    const show_list_button = document.getElementById(show_button_id);
    // retreive corresponding checkbox list
    const checkbox_list = document.getElementById(list_id);
    // store class which toggles list visibility
    const list_visibility_class = "filters__list--is_visible";
    // store class which toggles button's list being visible
    const button_list_visibility_class = "filters__filter_name--list_is_visible";
    if (show_list_button && checkbox_list) {
        // on click of button which makes list visible
        show_list_button.addEventListener("click", () => {
            // toggle visibility class on relevant list
            checkbox_list.classList.toggle(list_visibility_class);
            // toggle list visibility class on relevant button
            show_list_button.classList.toggle(button_list_visibility_class);
        });
    }
}
/*
    function to watch checkboxes in a list for changes
    and then update the text in the relevant filter name
*/
function update_filter_name (button_id, list_id, taxonomy_name_store_id) {
    // retreive filter button inner text
    const filter_button = document.getElementById(button_id);
    if (filter_button) {
        // retrieve text for when multiple checkboxes are selected
        const multiple_selected_text = document.getElementById("multiple_selected_text").innerText;
        // create script element to store original taxonomy name
        const taxonomy_name_store = document.createElement("script");
        taxonomy_name_store.setAttribute("id", taxonomy_name_store_id);
        taxonomy_name_store.setAttribute("type", "application/json");
        taxonomy_name_store.innerText = filter_button.innerText;
        // add script element to document
        document.head.appendChild(taxonomy_name_store);
        const taxonomy_name = document.getElementById(taxonomy_name_store_id).innerText;
        // retreive corresponding checkbox list
        const checkbox_list = document.getElementById(list_id);
        if (checkbox_list) {
            const currently_selected_filters = [];
            const checkboxes = checkbox_list.getElementsByClassName("filters__checkbox_input");
            if (checkboxes) {
                Array.from(checkboxes).forEach((checkbox) => {
                    function handle_filter_name () {
                        if (currently_selected_filters.length === 0) {
                            filter_button.innerText = taxonomy_name;
                        } else if (currently_selected_filters.length === 1) {
                            filter_button.innerText = taxonomy_name + ": " + checkbox_name;
                        } else {
                            filter_button.innerText = taxonomy_name + ": " + multiple_selected_text;
                        }
                    }
                    const checkbox_name = checkbox.getAttribute("data-filter-name");
                    checkbox.addEventListener("change", () => {
                        if (checkbox.checked) {
                            currently_selected_filters.push(checkbox_name);
                            handle_filter_name();
                        } else {
                            const checkbox_name_index = currently_selected_filters.indexOf(checkbox_name);
                            if (checkbox_name_index > -1) {
                                currently_selected_filters.splice(checkbox_name_index, 1);
                                handle_filter_name();
                            }
                        }
                    });
                });
            }
        }
    }
}
function show_applied_filters () {
    // check for applied filters element on page
    const notice = document.getElementById("applied_filters_message");
    if (!notice) {
        return;
    }
    let url_parameters = new URLSearchParams(window.location.search);
    url_parameters = Object.fromEntries(url_parameters.entries());
    if (url_parameters && Object.keys(url_parameters).length !== 0 && Object.getPrototypeOf(url_parameters) === Object.prototype) {
        const results_list = document.getElementById("applied_filters_message_results");
        for (let [key, value] of Object.entries(url_parameters)) {
            const results_item = document.createElement("li");
            results_item.classList.add("applied_filters_message__results__item");
            key = key.replace(/_/g, " ");
            value = value.replace(/-/g, " ").replace(/,/g, ", ");
            results_item.innerHTML = `<span class="applied_filters_message__results__taxonomy_name">${key}: </span><span class="applied_filters_message__results__taxonomy_item">${value}</span>`;
            results_list.appendChild(results_item);
        }
        notice.classList.remove("applied_filters_message--not_visible");
    }
}
export default function () {
    show_applied_filters();
    /*
        handle visibility of filter lists when user interacts with the relevant buttons
    */
    toggle_filter_list_visibility("issues_filter_show_button", "issues_filter");
    toggle_filter_list_visibility("due_diligence_stages_filter_show_button", "due_diligence_stages_filter");
    toggle_filter_list_visibility("regions_filter_show_button", "regions_filter");
    toggle_filter_list_visibility("business_sectors_filter_show_button", "business_sectors_filter");
    toggle_filter_list_visibility("resource_types_filter_show_button", "resource_types_filter");
    /*
        when user interacts with the filter button,
        construct and visit URL based on user's filter choice
    */
    const filter_button = document.getElementById("filters_submit_button");
    if (filter_button) {
        // when user interacts with the filter button
        filter_button.addEventListener("click", function () {
            const { protocol, host, pathname } = window.location;
            let url_without_query_parameters = `${protocol}//${host}${pathname}`;
            // check for pagination and remove it if present
            url_without_query_parameters = url_without_query_parameters.replace(/\/page\/.+?\//, "");
            // define current URL, including filters
            const query_url = new URL(url_without_query_parameters);
            // retrieve issues filter list, add query parameters if checkboxes are checked
            construct_query_parameters("issues_list", query_url, "related_issues");
            // retrieve due diligence stages filter list, add query parameters if checkboxes are checked
            construct_query_parameters("due_diligence_stages_list", query_url, "due_diligence_stages");
            // retrieve regions filter list, add query parameters if checkboxes are checked
            construct_query_parameters("regions_list", query_url, "regions");
            // retrieve business sectors filter list, add query parameters if checkboxes are checked
            construct_query_parameters("business_sectors_list", query_url, "business_sectors");
            // retrieve resource types filter list, add query parameters if checkboxes are checked
            construct_query_parameters("resource_types_list", query_url, "resource_types");
            // retrieve HTML element
            const html_element = document.documentElement;
            if (html_element) {
                // store value for language attribute on the HTML element
                const parameter_name = "lang";
                let language_code = html_element.getAttribute(parameter_name);
                // strip country code from the language code
                language_code = language_code.slice(0, language_code.indexOf("-"));
                if (language_code) {
                    // append language code to URL as a query parameter
                    query_url.searchParams.append(parameter_name, language_code);
                }
            }
            // visit the URL with all checked query parameters
            window.location.href = query_url;
        });
    }
    /*
        update the text in the relevant filter name when user selects taxonomy items
    */
    // handle visibility of issues filter list when user interacts with the relevant buttons
    update_filter_name("issues_filter_show_button", "issues_filter", "issues_filter_text_store");
    update_filter_name("due_diligence_stages_filter_show_button", "due_diligence_stages_filter", "due_diligence_stages_filter_text_store");
    update_filter_name("regions_filter_show_button", "regions_filter", "regions_filter_text_store");
    update_filter_name("business_sectors_filter_show_button", "business_sectors_filter", "business_sectors_filter_text_store");
    update_filter_name("resource_types_filter_show_button", "resource_types_filter", "resource_filter_text_store");
}
